import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";

export function withdrawPartnerFees({
  dst,
  partner,
  partnerFeeDestination,
}: {
  dst: PublicKey;
  partner: PublicKey;
  partnerFeeDestination: PublicKey;
}) {
  const program = makeDSTProgram();
  const result = program.methods.withdrawPartnerFees().accountsPartial({
    partner,
    dst,
    partnerFeeDestination,
  });

  return result;
}
